/**
 * Unit price box of an invoice / order item row. When the product has more than one price in its price lists, a dropdown
 * next to the box lists them all; picking one puts it in the box, and any other amount can still be typed.
 */
const UnitPriceInput = ({ value, onChange, options, required, placeholder }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
    <input
      type="number"
      min="0"
      step="0.01"
      style={{ width: "100px" }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      required={required}
      placeholder={placeholder}
    />
    {options && options.length > 1 ? (
      <select
        value=""
        onChange={(e) => e.target.value && onChange(e.target.value)}
        title="All prices of this product"
        aria-label="Pick a price"
        style={{ width: "auto", minWidth: 0 }}
      >
        <option value="">Prices</option>
        {options.map((price) => (
          <option key={price} value={price}>
            {price}
          </option>
        ))}
      </select>
    ) : null}
  </div>
);

export default UnitPriceInput;
